import axiosHttp from "services/axiosHttp";
import { MEAL_BASE_URL } from "configs/AppConfig";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchBranchList = createAsyncThunk("fetchBranchList", async ({ filters, page, limit, bankId }, { rejectWithValue }) => {

	const params = new URLSearchParams({
		page: page,
		limit: limit,
        bankId: bankId,
		keyword: filters?.keyword ?? "",
	});

	try {
		const response = await axiosHttp.get(`${MEAL_BASE_URL}/branches?${params}`);
		return response.data.data;
	} catch (error) {
		return rejectWithValue(error.response?.data?.message || "Something went wrong");
	}
});

const BranchListSlice = createSlice({
	name: "BranchListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchBranchList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchBranchList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.currentPage;
			state.total = action.payload.total;
		});

		builder.addCase(fetchBranchList.rejected, (state, action) => {
			state.isLoading = false;

			if (action.error.message) {
				state.error = action.error.message;
			} else {
				state.error = "Unknown error occurred";
			}
		});
	},
});

export default BranchListSlice.reducer;
